import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import {
  Icon,
  Counter,
  StyledIncrementalInput,
} from './incremental-input.styles';
export interface IncrementalInputProps {
  onChange: (counter: number) => void;
  counter: number;
  isValid: boolean;
  maxLimit?: number;
}

export function IncrementalInput({
  counter,
  onChange,
  isValid,
  maxLimit,
}: IncrementalInputProps) {
  const canDecrement = counter > 0;
  const canIncrement = !maxLimit || counter < maxLimit;
  return (
    <StyledIncrementalInput isValid={isValid}>
      <Icon
        data-testid="minus-button"
        src="/icons/minus1.png"
        enabled={canDecrement}
        onClick={() => (canDecrement ? onChange(counter - 1) : null)}
      />
      <Counter
        type="number"
        value={counter}
        onChange={(e) => onChange(parseInt(e.target.value))}
      />
      <Icon
        data-testid="plus-button"
        src="/icons/plus1.png"
        enabled={canIncrement}
        onClick={() => (canIncrement ? onChange(counter + 1) : null)}
      />
    </StyledIncrementalInput>
  );
}

export default IncrementalInput;
